import { render, staticRenderFns } from "./grieve.vue?vue&type=template&id=c96b864c&scoped=true&"
import script from "./grieve.vue?vue&type=script&lang=js&"
export * from "./grieve.vue?vue&type=script&lang=js&"
import style0 from "./grieve.vue?vue&type=style&index=0&id=c96b864c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96b864c",
  null
  
)

export default component.exports